import { Grid } from '@material-ui/core';
import { Loader } from 'components/Loader';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { PostsList } from '../PostsList';
import { useParams } from 'react-router-dom';
import { getPost } from 'redux/thunks/team';
import { Post } from 'redux/models/post';

const AllTokens: React.FC = () => {
	let { postId } = useParams<{ postId: string }>();
	const userState = useSelector((store: RootStore) => store.user);
	const teamState = useSelector((store: RootStore) => store.team);
	const dispatch = useDispatch();
	let postsListView;

	useEffect(() => {
		dispatch(getPost(postId));
	}, [dispatch, postId]);

	if (teamState.loading) {
		postsListView = (
			<div className='loader-wrapper'>
				<Loader />
			</div>
		);
	} else if (teamState.posts?.length > 0 && !teamState.loading) {
		postsListView = (
			<PostsList postsProp={teamState.currentPost ? [teamState.currentPost as Post] : []} userId={userState.userId} subpostsLoading={teamState.subpostsLoading} currentTeam={userState.selectedTeam} />
		);
	} else {
		postsListView = <div className='no-posts-message'>No tokens have been shared in this team. Send some today!</div>;
	}

	return (
		<>
			<Grid container direction='column' alignContent='center' alignItems='center'>
				{postsListView}
			</Grid>
		</>
	);
};

export default AllTokens;
